import gqlRequest from 'graphql/generic';

type RequestPasswordReset = {
  requestPasswordReset: {
    email: string;
  };
};

type RequestPasswordResetParams = {
  email: string;
};

const mutationRequestPasswordReset = `
 mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email) {
    email
  }
}
`;

export const gqlRequestPasswordReset = (params: RequestPasswordResetParams) => gqlRequest<RequestPasswordReset, RequestPasswordResetParams>(
  mutationRequestPasswordReset,
  params,
);

export default {};
